angular.module('shared').directive('emailDisabledMessage', function() {
  return {
    restrict: 'E',
    template: `<div class="alert alert-danger is-sm alert--links-underscored">
  Email functionality is currently limited while your account is under review. If you'd like to know more,
  <a href="mailto:support@clubworx.com?subject=Clubworx email access" target="_self">contact us today</a>.
</div>`
  };
});
